import { Checkbox } from '@lib/components'
import { Badge } from '@octopus-do/octopus-storybook'
import cx from 'classnames'
import type React from 'react'

import css from './BlocksTextOption.module.scss'

type Props = {
  className: string
  checked: boolean
  // The plan allows the model to write the block text; a free plan sees it as PRO.
  pro: boolean
  onChange: (checked: boolean) => void
  onUpgrade: () => void
}

// The one thing an "AI blocks" crawl is asked for on top of the blocks themselves
// (OCT-5091). Meta tags and the blocks come with the mode on every plan, so they
// are no longer options; the block text costs model calls and stays PRO.
export const BlocksTextOption: React.FC<Props> = ({
  className,
  checked,
  pro,
  onChange,
  onUpgrade,
}) => (
  <div className={cx(css.row, className)}>
    <Checkbox
      name="crawlBlocksContent"
      label="Fill blocks with text from the page"
      checked={pro && checked}
      disabled={!pro}
      onChange={onChange}
    />
    {!pro && (
      <span className={css.pro} onClick={onUpgrade}>
        <Badge type="pro" />
      </span>
    )}
  </div>
)
